import { MatTooltip } from '@angular/material/tooltip';
import { ValidationSeverity, ValidationError } from 'validation';
import { Unsafe } from './../unsafe/unsafe';

export class Control {
  static readBlob(blob: Blob, cb: (result: string) => void) {
    let reader = new FileReader();
    reader.onload = () => {
      const value = reader.result as string;
      const result = value.substr(value.indexOf(',') + 1);
      cb(result);
    };
    reader.readAsDataURL(blob);
  }

  validClass: string = '';
  validMessage: string = '';

  private tooltip: MatTooltip | null = null;

  preventMouseEvent(e: MouseEvent) {
    e.stopImmediatePropagation();
  }

  protected decorate(errors: ValidationError[]) {
    this.validClass =
      errors.length === 0
        ? ''
        : errors[0].severity === ValidationSeverity.ERROR
        ? 'validation-error'
        : errors[0].severity === ValidationSeverity.WARNING
        ? 'validation-warning'
        : 'validation-notice';
    this.validMessage = errors.length === 0 ? '' : errors[0].message;
  }

  protected showTooltip(tooltip: MatTooltip) {
    this.tooltip = tooltip;
    this.showCurrentTooltip();
  }

  protected showCurrentTooltip() {
    if (this.tooltip !== null) {
      this.tooltip.message = this.validMessage;
      this.tooltip.show();
      Unsafe.fixTooltip(this.tooltip);
    }
  }

  protected hideTooltip() {
    if (this.tooltip !== null) {
      this.tooltip.hide();
      this.tooltip = null;
    }
  }
}
